export default __webpack_public_path__ + "static/media/CNo.58-0.042b80f5.jpg";